import React, {useEffect} from 'react';

import Body from './../LearnMore/Body';
import Container from './../LearnMore/Container';
import analytics from "js/services/Analytics";
import AppUser from "js/stores/AppUser";
import UserCountry from "js/services/UserCountry";
import PubSub from "pubsub-js";
import * as clipboard from "clipboard-polyfill/text";
import {makeRequest} from "js/services/Network";
import {pick} from "lodash";
import {getSnapshot} from "mobx-state-tree";




const GenerateDiscountCode = () => {
  const [spinner, setSpinner] = React.useState(true);
  const [discount, setDiscount] = React.useState({});
  const [error, setError] = React.useState('');

  const generateCode = async () => {
    try {
      setTimeout(async () => {
        const response = await makeRequest('generate-discount-code', null, pick(AppUser, ['login']));
        setDiscount(response.data?.discount);
        // console.info(response)
        setSpinner(false);
      }, 3000);
      analytics.track('SP_generate_discount_code', {
        'Seller': AppUser.login,
        'Store URL:': AppUser.store_url,
        'Country': UserCountry(),
      });

    } catch (error) {
      console.info(error);
      setError(error.data
        ? error.data.message || error.data.statusText
        : 'Unknown error occurred');
    }
  }

  useEffect(()=>{
    generateCode().then(r => {
      // console.log(r)
    });
  },[]);

  const copyCode = () => {
    analytics.track('Discount Code Copied', {
      'Micro Seller': AppUser.login,
      'Store URL:': AppUser.store_url,
      'Country': UserCountry(),
    });

    PubSub.publish('popup-text', 'Code copied!');
    clipboard
      .writeText(discount.code)
      .then(() => {
        setTimeout(() =>  2000);
      })
      .catch(() => {
      });
  };

  return (
    <Container>
      <h5 style={{fontWeight:"bold"}}>Generate discount codes</h5>
      <Body>
        <p>
          Please hold on a second. A special code is being generated for you to send to your customers. This code is valid for 3 months.
        </p>
        {spinner ? (
          <div className="loading-spinner align-content-center" style={{marginLeft: '42%'}}>
            <img src="/images/spinner.svg"  alt={'Loading'}/>
          </div>
        ) : (
          <>
            <div className="d-flex align-items-center justify-content-evenly w-100">
              <div className="float-start tw-h-[44px]" style={{border:"black 4px dotted"}}>
          <span style={{lineHeight: '40px', paddingTop:'5px', paddingBottom:'5px', paddingLeft:'5px', paddingRight:'16px', font:'Nunito Sans', fontWeight:'bold', fontSize:'20px', color:'#334155', borderRadius:'10px'}}
                className="tw-py-3 tw-text-[#334155]">
            {discount?discount.code:error}
          </span>
              </div>
              <div className="float-end ">
                <button className="btn btn-pod tw-bg-secondary tw-py-3 tw-w-full tw-rounded-lg tw-mt-6 tw-text-white mb-3"
                        onClick={copyCode}>
                  <img
                    src="/images/icons/copy.svg"
                    alt="shop"
                    className="size-24px"
                  />&nbsp;&nbsp;
                  Copy discount code
                </button>
              </div>
            </div>

            <p className="text-center text-black text-sm">Copy and paste the code below, use on your social media</p>
          </>
        )}
      </Body>
    </Container>
  );
}

export default GenerateDiscountCode


